class TableOfContentsElement extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.table-of-contents__item'))
      .map((item) => {
        const link = item.querySelector('a[href^="#"]');
        const id = link ? decodeURIComponent(link.hash.slice(1)) : '';
        const target = id ? document.getElementById(id) : null;
        return target ? { item, target } : null;
      })
      .filter(Boolean);

    if (!this._items.length) {
      return;
    }

    // The observer only serves as a trigger: headings crossing the activation
    // line are exactly the moments the active section can change. rootMargin
    // pulls the observation band's bottom up so the line sits ~30% from the top.
    this._observer = new IntersectionObserver(() => this._update(), {
      rootMargin: '0px 0px -70% 0px',
    });
    this._items.forEach(({ target }) => this._observer.observe(target));
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  _update() {
    // Active section is the last heading that has scrolled up past the activation
    // line. This keeps any text blocks between headings attributed to the heading
    // above them, rather than leaving nothing active in the gap. Before the first
    // heading reaches the line, the first section is treated as current.
    const activationLine = window.innerHeight * 0.3;
    const active =
      this._items.findLast(({ target }) => target.getBoundingClientRect().top <= activationLine)
      ?? this._items[0];

    this._items.forEach(({ item }) => {
      if (item === active.item) {
        item.setAttribute('data-active', 'true');
      } else {
        item.removeAttribute('data-active');
      }
    });
  }
}

customElements.define('chh-table-of-contents', TableOfContentsElement);

export default TableOfContentsElement;
